import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/1.jpg';
// import p2 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/2.jpg';
// import p3 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/3.jpg';
// import p4 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/4.jpg';
// import p5 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/5.jpg';
// import p6 from 'assests/Photos/Clubs/EcoClub/2024/EnvironmentDay3to5/6.jpg';


import Ecoclub2023 from 'views/EnvironmentDay2023/Ecoclub2023';

import SideHealth from 'views/HealthAndWellnesClub/SideHealth';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import EcoAssociationSidebar2025 from '../EcoAssociationSidebar2025';
import Sidebar from '../EcoClub/Sidebar';


const EcoAssociation10Class2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/association/ecoassociation/ecoassociation10/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/association/ecoassociation/ecoassociation10/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/association/ecoassociation/ecoassociation10/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/association/ecoassociation/ecoassociation10/4.webp`;
  


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
      Sustainable Gardening and Greenhouse Design Competition
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 10  &  Date: 09 June 2025
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The Eco Association organized an Activity: “Sustainable Gardening and Greenhouse Design Competition” for the students of Class 10 on 9 June 2025 in AV room. It was a much-anticipated event filled with innovation and creativity. The competition focused on environmental awareness. Students presented dynamic model-making projects. Young minds came together with a shared goal—to shape a greener future.
        <br></br>
       The event witnessed enthusiastic participation from students who showcased miniature, yet mighty models of sustainable gardens and futuristic greenhouse systems. The competition aimed to promote awareness of eco-friendly agricultural practices and foster hands-on learning through design and model construction. 
        <br></br>
       The Sustainable Gardening and Greenhouse Design Competition was a powerful reminder that meaningful change often begins with small steps and young minds. Through their thoughtful models and innovative solutions, students not only demonstrated technical skill and environmental awareness but also a deep-rooted commitment to building a sustainable future. Events like these empower the youth to think critically, act responsibly and become the change makers that our planet urgently needs. As their ideas take root, they pave the way for a greener, healthier tomorrow.
       <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
      "A greenhouse built with purpose and a garden grown with care are the first steps toward a more sustainable tomorrow." 

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoAssociationSidebar2025/>
             </Box>
             <Box marginBottom={4}>
               <Sidebar/>
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EcoAssociation10Class2025;